import Vue from 'vue';
import AxScopelessbar from './AxScopelessbar.vue';
import Vuex from 'vuex';
import { Store } from 'vuex';
Vue.use(Vuex);

export default Vue.extend({
    name: 'ax-scopelessbar',
    components: {
        AxScopelessbar,
    },
    store: new Store({}),
    props: {
        username: {
            type: String,
            required: false,
        },
        enableHelpPanel: {
            type: Object,
            default: false,
        },
    },
    render(createElement) {
        return createElement(AxScopelessbar, {
            props: {
                username: this.username,
                enableHelpPanel: true, // always true for scopelessbar
            }
        })
    }
})
